/**
 * Convert a file into a base64 representation.
 * This is primarily use to render an image in place.
 *
 * @param {File} file - File to convert
 * @return {Promise<string>}
 */
export function toBase64(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});
}

/**
 * Preload an image, and return a promise resolving when the image has been
 * loaded.
 *
 * @param {string} url - Url of the picture to preload
 * @param {boolean} [manualRemove] - When true, the function won't remove the
 *   preload DOMNode automatically. This can be useful if you want to use the
 *   preload as a placeholder, or if you want to make sure the actual image is
 *   loaded before removing the preload
 * @return {Promise<DOMNode>}
 */
export function preloadPicture({ url, manualRemove = false }) {
	return new Promise((resolve) => {
		const preload = document.createElement("img");
		preload.classList.add("preload");

		const onResolve = () => {
			resolve(preload);

			if (!manualRemove) {
				setTimeout(() => {
					preload.parentElement?.removeChild(preload);
				}, 1000);
			}
		};

		preload.setAttribute("src", url);

		preload.style.position = "absolute";
		preload.style.left = "-1000000000000000000000000000000000000px";
		preload.style.top = "-1000000000000000000000000000000000000px";

		preload.addEventListener("load", onResolve);

		document.body.appendChild(preload);
	});
}
